import { useSearchParams, Link } from "react-router-dom";
import { BsCheckCircleFill, BsWhatsapp } from "react-icons/bs";

const PaymentModal = () => {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "";
  const plan = params.get("plan") || "";
  const refNo = params.get("refNo") || "";
  const amount = params.get("amount") || "";

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 font-Montserrat">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 w-full max-w-md p-8 text-center">

        <div className="flex justify-center mb-5">
          <BsCheckCircleFill className="text-green-500 text-6xl" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful!</h1>
        <p className="text-gray-500 text-sm mb-7">
          Thank you for your purchase. We'll process your plan and deliver it within 24 hours.
        </p>

        <div className="bg-gray-50 rounded-xl p-5 text-left space-y-3 mb-7">
          {plan && (
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Plan</span>
              <span className="font-semibold text-gray-900 text-right max-w-[60%]">{plan}</span>
            </div>
          )}
          {refNo && (
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Plan Ref</span>
              <span className="font-semibold text-gray-900">{refNo}</span>
            </div>
          )}
          {amount && (
            <div className="flex justify-between text-sm">
              <span className="text-gray-500">Amount Paid</span>
              <span className="font-bold text-[#1877F2]">
                ₦{Number(amount).toLocaleString()}
              </span>
            </div>
          )}
          {ref && (
            <div className="flex justify-between text-sm border-t border-gray-200 pt-3 mt-3">
              <span className="text-gray-500">Transaction Ref</span>
              <span className="font-mono text-xs text-gray-700 text-right max-w-[60%] break-all">{ref}</span>
            </div>
          )}
        </div>

        <a
          href={`https://wa.me/+2349033020343?text=Hi, I just purchased plan ${refNo}. My transaction reference is ${ref}.`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#1da851] text-white font-bold py-3.5 rounded-full transition-colors duration-200 text-sm mb-3"
        >
          <BsWhatsapp />
          Send Reference on WhatsApp
        </a>

        <Link
          to="/featured-house-plans"
          className="block w-full text-center border-2 border-gray-200 hover:border-[#1877F2] hover:text-[#1877F2] text-gray-600 font-semibold py-3 rounded-full transition-colors duration-200 text-sm"
        >
          Browse More Plans
        </Link>

        <p className="text-xs text-gray-400 mt-5">
          Questions? WhatsApp us at +234 903 302 0343
        </p>
      </div>
    </div>
  );
};

export default PaymentModal;
